import {ApolloProvider} from '@apollo/client';
import {ThemeProvider} from '@mui/material/styles';
import React from 'react';
import {Helmet} from 'react-helmet';
import {Provider as ReduxProvider, useDispatch, useSelector} from 'react-redux';
import {ToastContainer} from 'react-toastify';
import 'symbol-observable';
import initApolloClient from './initApolloClient';
import {store} from './redux';
import {loginFail, loginSuccess} from './redux/Auth/slice';
import {RouterComponent as RouterDash} from './router/router';
import {RouterAuthComponent as RouterAuth} from './router/router-auth';
import {GlobalStyle} from './theme';
import {theme} from './theme/mui-theme';

import 'moment/locale/pt-br';
import './utils/array';

function Apollo({children}) {
  const dispatch = useDispatch();
  const [client, setClient] = React.useState(null);
  const {token, refresh_token} = useSelector((state) => state.Auth);

  const onSucessRefresh = (authorization) => {
    dispatch(loginSuccess(authorization));
  };

  const onFailRefresh = (authorization) => {
    dispatch(loginFail());
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const configureApollo = () => {
    const client = initApolloClient({
      refresh_token,
      onSucessRefresh,
      onFailRefresh,
    });

    setClient(client);
  };

  React.useEffect(() => {
    token && configureApollo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !client ? (
    <div />
  ) : (
    <ApolloProvider client={client}>{children}</ApolloProvider>
  );
}

const Main = () => {
  const dispatch = useDispatch();
  const {logged} = useSelector((state) => state.Auth);

  React.useEffect(() => {
    const Auth = JSON.parse(window.localStorage.getItem('auth'));
    if (Auth) {
      dispatch(loginSuccess(Auth));
    } else {
      dispatch(loginFail());
    }
  });

  if (logged === undefined) {
    return null;
  }

  return logged ? (
    <Apollo>
      <RouterDash />
    </Apollo>
  ) : (
    <RouterAuth />
  );
};

function App() {
  const [isShown] = React.useState(true);

  return (
    <ReduxProvider store={store()}>
      <ThemeProvider theme={theme}>
        <>
          <Helmet>
            <html lang="pt-BR" />
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link
              rel="preconnect"
              href="https://fonts.gstatic.com"
              crossorigin
            />
            <link
              href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,400;0,500;0,600;0,700;0,900;1,500&display=swap"
              rel="stylesheet"
            />
            <link
              href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;400;500;600;700;900&display=swap"
              rel="stylesheet"
            />
            <link
              href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@100;400;500;600;700;900&display=swap"
              rel="stylesheet"
            />
          </Helmet>
          <GlobalStyle />
          {isShown ? <Main /> : <div />}
          <ToastContainer />
        </>
      </ThemeProvider>
    </ReduxProvider>
  );
}

export default App;
